import React, { FC } from 'react';
import { icon } from './const';
import { MessageStatusType } from './types';

type MessageStatusIconProps = {
	status: MessageStatusType;
};

export const MessageStatusIcon: FC<React.PropsWithChildren<MessageStatusIconProps>> = ({ status }) => {
	const MessageIcon = icon[status];

	return <MessageIcon />;
};
